import { connect } from 'react-redux';
import { questionKey } from '../response/reducer';
import PureHiddenInput from './PureHiddenInput';

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  const { value } = question;
  return {
    value: value === '' ? '' : `rating${value}`,
  };
};

const HiddenInput = connect(mapStateToProps)(PureHiddenInput);

export default HiddenInput;
